import { APISettings } from './apiConfig';

export const APIUrl = {
  AUTH_LOGIN_URL: APISettings.apiServerURL + 'auth/login',
  SUBMISSIONS_API: APISettings.apiServerURL + 'admin/bookings',
  NEW_SUBMISSION_API: APISettings.apiServerURL + 'bookTicket/admin',
  SEND_EMAIL_API: APISettings.apiServerURL + 'sendEmail',
  DOWNLOAD_TICKET_API: APISettings.apiServerURL + 'downloadTicket'
};
